// La ruta del modo Catálogo (ADR-2026-10-13-catalogo-con-el-agente). Sin `:sesionId` es la
// portada; con él, la sesión. Sólo marcas de Hogar y Decoración (los dev testers lo ven con
// cualquier marca, para probarlo). Desde el 2026-10-15 también en el teléfono, con el agente en
// una pastilla abajo (ADR-2026-10-15-el-catalogo-en-el-telefono). Entrar no pide plan: generar
// chequea el saldo adentro.
import { Sofa } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useRubroMarcaActiva } from '../../../../hooks/useRubroMarca';
import { useUserGroup } from '../../../../hooks/useUserGroup';
import { esRubroHogarDeco } from '../../../../lib/rubro';
import { PantallaCatalogo } from './PantallaCatalogo';

const Aviso: React.FC<{ icono: React.ReactNode; titulo: string; texto: string }> = ({ icono, titulo, texto }) => (
  <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
    {icono}
    <p className="text-[16px] font-semibold text-brand-black">{titulo}</p>
    <p className="max-w-md text-[14px] text-[#3C3C43]/60">{texto}</p>
  </div>
);

const CatalogoAgenteMode: React.FC = () => {
  const { sesionId } = useParams<{ sesionId?: string }>();
  const { rubro, loaded } = useRubroMarcaActiva();
  const { isDevTester } = useUserGroup();

  if (loaded && !esRubroHogarDeco(rubro) && !isDevTester) {
    return (
      <Aviso
        icono={<Sofa className="h-8 w-8 text-[#02062B]/[0.4]" aria-hidden="true" />}
        titulo="Catálogo es para Hogar y Decoración"
        texto="Este modo arma catálogos de muebles y decoración. Con otra marca, usá Generación en lote."
      />
    );
  }
  return <PantallaCatalogo sesionId={sesionId} />;
};

export default CatalogoAgenteMode;
